export const COOKIE_SWIPE_EXPLAINER = 'swipe_hint'

export const COOKIE_SCRATCHCARD_TUTORIAL = 'scratchmode_tutorial_visited'

export const COOKIE_LEGACY_WARNING = 'legacy_warning'
